import config from "./config";

const onApiError = (e) => {
    throw e;
};

const onApiSuccess = (res) => res;


const invokeApi = ({
    path,
    method = "GET",
    headers = {},
    authorization = false,
    body,
}) => {
    var apiUrl = config.API_URL + path;

    body = body && JSON.stringify(body);
    return fetch(apiUrl, {
        method,
        body,
        headers,
    }).then((results) => {

        if (results.status !== 200) {
            return results.json().then((data) => {
                return Promise.reject(data);
            });
        }

        return results
            .json()
            .then((json) => {
                return Promise.resolve(json);
            })
            .catch((err) => Promise.reject(err));
    });
};

export const getEvents = () =>
    invokeApi({
        method: "GET",
        path: `/events`,
        headers: {},
    }).then(onApiSuccess, onApiError);